import React from 'react';

export default function RechnungValidierenSectionTestimonialsWhitePattern7() {
    return (
        <React.Fragment>
            <>
                <section className="py-24 md:pb-28 bg-white" style={{backgroundImage: 'url("flex-ui-assets/elements/pattern-white.svg")', backgroundPosition: 'center'}}>
  <div className="container px-4 mx-auto">
    <div className="flex flex-wrap items-center justify-center lg:justify-between -mx-4">
      <div className="w-auto px-4 order-last lg:order-first">
      </div>
      <div className="w-full lg:w-2/6 px-4 mb-12 lg:mb-0">
        <div className="flex items-center">
          <img className="w-20 md:w-24 h-20 md:h-24 mr-6 rounded-full" src="flex-ui-assets/images/testimonials/avatar1.png" alt />
          <div>
            <h3 className="mb-2 text-xl md:text-2xl font-semibold">Daniel Dreml</h3>
            <span className="text-lg text-coolGray-500 font-medium">CEO </span>
          </div>
        </div>
      </div>
      <div className="w-full lg:w-2/6 px-4 mb-12 lg:mb-0">
        <div className="relative pt-12 pb-6 sm:p-6">
          <img className="absolute top-0 left-0" src="flex-ui-assets/elements/testimonials/quote-top-green.svg" alt />
          <img className="absolute bottom-0 right-0" src="flex-ui-assets/elements/testimonials/quote-down-green.svg" alt />
          <div className="relative">
            <h2 className="text-2xl font-semibold tracking-tighter">Handyfoto und schon ist die Rechnung beim Steuerberater. Love it.</h2>
          </div>
        </div>
      </div>
      <div className="w-auto px-4 order-last">
      </div>
    </div>
  </div>
</section>


            </>
        </React.Fragment>
    );
}

